/* LOVEQUEEN - 商品ページの拡大画面(#galModal)で、横スワイプで前後の写真へ移動する（スマホ向け） */
(function () {
  'use strict';
  function init() {
    var modal = document.getElementById('galModal');
    if (!modal || modal.dataset.lqSwipe) return;
    modal.dataset.lqSwipe = '1';
    var content = document.getElementById('modalSlidesContainer') || modal;
    var sx = null, sy = null, st = 0;

    function currentIndex() {
      var slides = modal.getElementsByClassName('galSlides');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].style.display === 'block') return i + 1;
      }
      return window.slideIndex || 1;
    }
    function go(dir) {
      var slides = modal.getElementsByClassName('galSlides');
      if (slides.length < 2 || typeof window.currentSlide !== 'function') return;
      var next = currentIndex() + dir;
      if (next > slides.length) next = 1;
      if (next < 1) next = slides.length;
      window.currentSlide(next);
    }

    content.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) { sx = null; return; }
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; st = Date.now();
    }, { passive: true });

    content.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      sx = null;
      /* ピンチ等で拡大中は、横の動きはスクロールに使うので切り替えない */
      if (modal.classList.contains('gallery-mega-zoom')) return;
      if (Date.now() - st > 800) return;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });

    /* PC: ←→キーでも前後へ */
    document.addEventListener('keydown', function (e) {
      if (!modal.classList.contains('open')) return;
      if (e.key === 'ArrowRight') go(1);
      else if (e.key === 'ArrowLeft') go(-1);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
